import type { RemoteCommandsModuleEvents } from "./RemoteCommands.types.ts";

type EventName = keyof RemoteCommandsModuleEvents;
type EventListener<E extends EventName> = RemoteCommandsModuleEvents[E];

interface RemoteCommandsWebStub {
  addListener<E extends EventName>(event: E, listener: EventListener<E>): { remove(): void };
  setEnabled(enabled: boolean): void;
}

// Web has no lock-screen transport controls; mirror the native surface as
// no-ops so consumers don't branch.
const stub: RemoteCommandsWebStub = {
  addListener() {
    return { remove() {} };
  },
  setEnabled() {},
};

export const NativeModule = stub;
